import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { navigate } from "@reach/router";
import { adminRoutes, investorsRoutes } from "Routes";
import Auth from "Api/Auth";
import Api from "Api/Api";
import Utils from "Utils";
function mapStateToProps(state) {
  return {
    notifications: state.notifications
  };
}
class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: []
    };
    this.markAsRead = notiID => {
      var readNotifications = [];
      if (notiID) {
        readNotifications = [notiID];
      } else {
        this.state.notifications.forEach(noti => {
          if (!noti.seen) {
            readNotifications.push(noti.id);
          }
        });
      }
      Api.markAsRead({
        notificationIDs: readNotifications
      }).then(response => {
        if (response.status === 200) {
          this.props.dispatch({
            type: "MarkAsRead",
            payload: readNotifications
          });
          Utils.notify("Notification mark as Read successfully", "success");
        }
      });
    };
    this.clicked = data => {
      var routes = Auth.decodedToken().moderator
        ? adminRoutes
        : investorsRoutes;
      var to = routes.filter(route => {
        return route.notificationType === data.page;
      })[0].to;

      if (!data.seen) {
        this.markAsRead(data.id);
      }
      navigate(to, { state: { highlightData: data.json } });
    };
  }
  static getDerivedStateFromProps(props, state) {
    return {
      notifications: props.notifications
    };
  }
  componentDidMount() {
    // to change the header in the navbar everytime this page is rendered
    this.props.dispatch({
      type: "SectionSelected",
      payload: "Notifications"
    });
  }

  render() {
    return this.state.notifications.length ? (
      <>
        {this.state.notifications.map(noti => {
          return (
            <div
              className="row notification-card"
              key={noti.id}
              onClick={() => {
                this.clicked(noti);
              }}
            >
              <div className="col-lg-9 col-md-7 col-12 text">
                {noti.seen ? null : <i class="fa fa-circle readStatus"></i>}
                {noti.title}
              </div>
              <div className="col-lg-2 col-md-4 col-6 time">
                {moment(noti.created).fromNow()}
              </div>
              {noti.seen ? null : (
                <i className="col-lg-1 col-md-1 col-1 mark-as-read">
                  <i
                    class="im im-check-mark"
                    onClick={() => {
                      this.markAsRead(noti.id);
                    }}
                  ></i>
                </i>
              )}
            </div>
          );
        })}
        <button
          className="btn btn-primary float-right"
          onClick={() => {
            this.markAsRead();
          }}
        >
          Mark All as read
        </button>
      </>
    ) : (
      <div>No notifications here</div>
    );
  }
}
export default connect(mapStateToProps)(Notifications);
